import React = require('react');
import {IWizard} from './models';
import {Question} from './Question';
import {IChoice} from "./models";
import Immutable = require('immutable');
import {IQuestion} from "./models";

interface Properties {
    currentQuestion: number
    userChoices: string[]
    questions: IQuestion[]
}

interface Callbacks {
    onClick: (index: number) => void    // Triggered when a navigation item gets clicked
}

interface Props extends Properties, Callbacks {}

interface State {
}

export class Navigation extends React.Component<Props, State> {

    handleClick(index) {
        if (index < this.props.currentQuestion) {
            return () => this.props.onClick(index);
        }
        return () => {}
    }

    componentWillReceiveProps(newProps) {
        if (newProps.currentQuestion !== this.props.currentQuestion && document.querySelectorAll('.cc-navigation__item')[newProps.currentQuestion]) {
            document.querySelectorAll('.cc-navigation__item')[newProps.currentQuestion].scrollIntoView()
        }
    }

    render() {

        var questions = Immutable.List(this.props.questions).skipLast(1);

        var items = questions.map( (question, index) => {
            var placeholder = <span>&nbsp;</span>;
            var modifiers = [];

            if (this.props.currentQuestion == index) {
                modifiers.push('-cc-current');
                placeholder = <span>&nbsp;</span>;
            }

            if (this.props.userChoices[index]) {
                modifiers.push('-cc-filled');
            }

            var navigationItemStyle = {
                width: 100 / questions.size + '%'
            };

            return <div
                className={"cc-navigation__item " + modifiers.join(' ')}
                key={index}
                onClick={this.handleClick(index).bind(this)}
                style={navigationItemStyle}
            >
                <div className="cc-navigation__item-question">{question.name}</div>
                <div className="cc-navigation__item-number">
                    <div className="cc-navigation__item-number__flipper">
                        <div className="cc-navigation__item-number__front"></div>
                        <div className="cc-navigation__item-number__back">
                            {/* <img className="cc-navigation__item-number__tick" src="images/tick-white.png" /> */}
                        </div>
                    </div>
                </div>
                <div className="cc-navigation__item-choice">
                    {this.props.userChoices[index] || placeholder}
                </div>
            </div>
        });

        var barStyle = {
            left: 100/questions.size / 2 + '%',
            right: 100/questions.size / 2 + '%',
            minWidth: 100 * (questions.size - 1)
        };

        var progressStyle = {
            width: Math.min( this.props.currentQuestion / (questions.size - 1) * 100, 100) + '%'
        };

        return <div className="cc-navigation clearfix center-block">
            <div className="cc-navigation__items-wrapper">
                <div className="cc-navigation__items-wrapper-scrollable">
                    <div className="cc-navigation__bar" style={barStyle}>
                        <div className="cc-navigation__bar__progress" style={progressStyle}></div>
                    </div>
                    {items}
                </div>
            </div>
        </div>
    }
}
